import { AppPalette } from '../colors'

export const lightPalette = {
  primary: {
    main: AppPalette.GREEN.main,
    contrastText: AppPalette.GREEN.main,
  },
  text: {
    primary: AppPalette.NEUTRAL.white,
    main: AppPalette.BLACK.main,
    secondary: AppPalette.GREY.light,
    disabled: AppPalette.GREY.highlight_light,
  },
  background: {
    default: AppPalette.NEUTRAL.first,
    overrideDefault: AppPalette.GREY.light,
    secondary: AppPalette.NEUTRAL.light,
    dialog: AppPalette.NEUTRAL.second,
    dark: AppPalette.BORDER.light,
    bgIconFirst: AppPalette.NEUTRAL.light,
    hoverFirst: AppPalette.GREY.highlight_light,
    bgIcon: AppPalette.GREY.third,
    bgButton: AppPalette.GREEN.main,
  },
  link: {
    main: AppPalette.BLUE.main,
  },
  highlight: {
    main: AppPalette.GREY.highlight_light,
  },
  overdueState: {
    overdue: AppPalette.SLA_STATE.overdue_light,
    on_time: AppPalette.SLA_STATE.on_time_light,
  },
  success: {
    main: AppPalette.GREEN.main,
  },
  createTicketBackground: {
    main: AppPalette.NEUTRAL.white,
  },
  border: {
    main: AppPalette.BORDER.light,
    first: AppPalette.BORDER.darkerBold,
    devider: AppPalette.BORDER.devider,
  },

  warning: {
    main: '#EECD1D',
  },

  grey: {
    600: '#7C7B7B',
    700: '#747474',
    800: '#5C5C5C',
  },
  error: {
    main: AppPalette.RED.dark,
    light: AppPalette.RED.error,
  },
  color: {
    button: {
      icon: '#fff',
      label: '#fff',
      labelActive: '#66f0a0',
    },
    label: '#000',
    chip: {
      label: '#004744',
      labelActive: '#fff',
    },
    border: {
      box: '#ebedec',
    },
    text: {
      black: '#000',
      white: '#fff',
      tabHeaderActive: '#004744',
      table: {
        header: '#002031',
        body: '#002031',
      },
    },
  },
  backgroundColor: {
    box: '#fff',
    wrapper: '#ebedec',
    table: {
      rowActive: '#f3f4f4',
    },
  },
}
